import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import Loading from "../../../../../../components/Loading/Loading";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";
import { useToggle } from "../../../../../../hooks/useToggle";
import localeText from "../../../../../../locale";
import useConversionList from "../../hooks/useConversionList";
import ConvertExtraCoinToWalletModal from "../ConvertExtraCoinToWalletModal";
import "./styles.css";

const ConversionList = () => {
  const { value: visible, setAsFalse: closeModal, setAsTrue: openModal } = useToggle();
  const { showErrorToast } = useToastContext();
  const {
    conversions,
    isLoading,
    setRetryFetch: setRetryFetchConvertions,
  } = useConversionList({
    onError: (code) => showErrorToast({ code }),
  });

  const onSuccess = () => {
    setRetryFetchConvertions(true);
  };

  const columns = [
    {
      field: "untilConversion",
      header: localeText("conversionExpiration"),
      body: ({ untilConversion }) => {
        const date = new Date(untilConversion);
        let dia = date.getDate();
        let mes = date.getMonth() + 1;
        const ano = date.getFullYear();

        if (mes < 10) mes = `0${mes}`;
        if (dia < 10) dia = `0${dia}`;

        return `${dia}/${mes}/${ano}`;
      },
    },
    { field: "conversionRate", header: localeText("conversionRate") },
    {
      field: "id",
      body: (rowData) => (
        <ConvertExtraCoinToWalletModal
          className="md:text-base text-xs"
          conversion={rowData}
          closeModal={closeModal}
          openModal={openModal}
          onSuccessProps={onSuccess}
          visible={visible}
        />
      ),
    },
  ];

  if (isLoading) return <Loading classNameIcon="text-4xl" />;
  if (!conversions.length) return <p className="text-center">{localeText("noConversions")}</p>;

  const conversionsNotExpired = conversions.filter((conversion) => {
    const now = new Date();
    const untilConversion = new Date(conversion.untilConversion);
    return now < untilConversion && conversion.converted === false;
  });

  if (!conversionsNotExpired.length)
    return <p className="text-center extrapay-conversions my-5">{localeText("noConversions")}</p>;

  return (
    <div className="mt-4 extrapay-conversions">
      <DataTable value={conversionsNotExpired} tableStyle={{ minWidth: "50rem" }}>
        {columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            body={col.body}
            className="md:text-base text-xs"
          />
        ))}
      </DataTable>
    </div>
  );
};

export default ConversionList;
